import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token) setError("Missing or invalid reset token.");
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords don't match.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-x py-16 lg:py-24" data-testid="reset-password-page">
      <div className="max-w-md mx-auto card-soft p-8 lg:p-10">
        <h1 className="font-outfit text-3xl font-medium text-ink">Set a new password</h1>
        <p className="font-manrope text-sm text-ink-soft mt-2">
          Choose something you'll remember. At least 6 characters.
        </p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="font-manrope text-sm text-ink mb-1 block">New password</label>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-soft"
              data-testid="reset-password-input"
            />
          </div>
          <div>
            <label className="font-manrope text-sm text-ink mb-1 block">Confirm new password</label>
            <input
              type="password"
              required
              minLength={6}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="input-soft"
              data-testid="reset-confirm-input"
            />
          </div>
          {error && <div className="tag-pill !bg-red-50 !text-red-700" data-testid="reset-error">{error}</div>}
          <button type="submit" disabled={submitting || !token} className="btn-primary w-full" data-testid="reset-submit-btn">
            {submitting ? "Saving…" : "Set new password"}
          </button>
          <p className="font-manrope text-sm text-ink-soft text-center">
            <Link to="/login" className="text-brand font-medium hover:underline">
              Back to sign in
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
